import {
  getPlaceSuggestions
} from "./chunk-UGCTIQP7.js";
import {
  getSuggestionsByDisplayId
} from "./chunk-R4Y3QH3V.js";
import {
  hasDisplayIdPrefix
} from "./chunk-KEXENXJJ.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";

// src/services/getSuggestions/getSuggestions.ts
async function getSuggestions(query, options, apiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, "getSuggestions");
  if (hasDisplayIdPrefix(query)) {
    const response = await getSuggestionsByDisplayId(query, options, _apiConfig);
    return response.status === "success" ? { status: "success", data: { type: "properties", data: response.data } } : response;
  } else {
    const response = await getPlaceSuggestions(query, options, _apiConfig);
    return response.status === "success" ? { status: "success", data: { type: "locations", data: response.data } } : response;
  }
}

export {
  getSuggestions
};
